export default "__VITE_ASSET__CJFnsm9A__"